export default __webpack_public_path__ + "static/media/profile-pic.66c5c569.jpg";